/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { GuestWorkbook } from "./GuestWorkbook";
import { GuestSheet } from "./GuestSheet";
export const GuestSpace = core.serialization.object({
    id: SpaceId,
    workbooks: core.serialization.list(GuestWorkbook).optional(),
    sheets: core.serialization.list(GuestSheet).optional(),
    lastAccessed: core.serialization.date().optional(),
});
